'use client';

import { useCallback, useEffect, useState } from 'react';

import ScrollUpIcon from '@/assets/icons/messengers/scroll-up.svg';
import TelegramIcon from '@/assets/icons/messengers/telegram.svg';
import { Button } from '@/components/ui/button';
import { Link } from '@/i18n/navigation';
import { cn } from '@/lib/utils/cn';

function Messengers() {
  const [showIcons, setShowIcons] = useState(false);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const scroll = useCallback(() => {
    if (window.scrollY > window.innerHeight && !showIcons) {
      setShowIcons(true);
    } else if (window.scrollY <= window.innerHeight && showIcons) {
      setShowIcons(false);
    }
  }, [showIcons]);

  useEffect(() => {
    window.addEventListener('scroll', scroll);

    return () => {
      window.removeEventListener('scroll', scroll);
    };
  }, [scroll]);

  return (
    <div
      className={cn(
        `fixed right-4 md:right-7.5 top-3/4 md:top-4/5 -translate-y-1/2 z-50 flex flex-col items-center transition-all ${showIcons ? 'opacity-100 pointer-events-all scale-100' : 'opacity-0 pointer-events-none scale-0'}`
      )}
    >
      <div
        className={
          'flex flex-col items-center transition-all duration-300 ease-in-out max-h-50 opacity-100 translate-y-0'
        }
      >
        <Button
          variant="link"
          size="icon"
          className="w-12 h-12 p-0 mb-3 border-0 shadow-(--telegram-shadow) bg-(image:--telegram-gradient) rounded-full flex items-center justify-center transition-transform duration-300"
          asChild
        >
          <Link
            href={
              process.env.TELEGRAM_CHANNEL_URL || 'https://t.me/trendex_one'
            }
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open Trendex Telegram"
          >
            <TelegramIcon className="w-7 h-6" />
          </Link>
        </Button>
      </div>

      <Button
        variant="default"
        size="icon"
        className={cn(
          'p-0 w-12 h-12 rounded-full flex items-center justify-center transition-transform duration-300'
        )}
        icon={<ScrollUpIcon className="w-6 h-6" />}
        onClick={scrollToTop}
        aria-label="Scroll to top"
      />
    </div>
  );
}

export default Messengers;
